import React, {useState} from 'react'
import { FaMinus, FaPlus } from 'react-icons/fa';
import { useNavContext } from '../../context-api/nav-context'


const SingleQuestion = ({title, body}) => {
    const [isOpen, setIsOpen] = useState(false)
    const {closeNavbarMenu} = useNavContext();

    const clickHandler = () => {
        setIsOpen(!isOpen);
    }
  return (
     <div className="questions-container" onMouseOver={closeNavbarMenu}>
         <div className="question-title">
             <h5 className="card-small-title">{title}</h5>
             <button onClick={clickHandler} className="icon-btn">{isOpen ? <FaMinus/> : <FaPlus/>}</button>
         </div>
         {isOpen && <div className="question-body">
              <p className="card-small-p question-text">{body}</p>
              </div>}
    </div>
  )
}

export default SingleQuestion
